module.exports = __webpack_public_path__ + "static/media/usina-fortlev.e3c79498.jpg";